'use client'
import React from 'react'
import { useRouter } from 'next/navigation'

import { ChevronLeft } from 'lucide-react'

import { 
  Button, 
  buttonVariants, 
} from '@hanzo/ui/primitives'
import { css, type ButtonSize, type ButtonVariant } from '@hanzo/ui'
const BackButton: React.FC<{
  variant?: { variant?: ButtonVariant | null; size?: ButtonSize | null }['variant']
  size?: { variant?: ButtonVariant | null; size?: ButtonSize | null }['size']
  onBack?: () => void
  clx?: string
  iconClx?: string
}> = ({
  variant='ghost',
  size='default',
  clx='',
  iconClx='',
  onBack
}) => {

  const router = useRouter()
  const back = () => {
    if (onBack) {
      onBack()
    }
    router.back()
  }

  return (
    <Button
      variant={variant}
      size={size}
      onClick={back}
      className={clx}
    >
      <ChevronLeft style={css(iconClx)}/>
    </Button> 
  )
}

export default BackButton
